import DatePickerLocale from 'rmc-date-picker/es/locale/zh_CN';
export default {
    okText: '确定',
    dismissText: '取消',
    extra: '请选择',
    DatePickerLocale: DatePickerLocale
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/date-picker/locale/zh_CN.js
// module id = 328
// module chunks = 0